module.exports = __webpack_public_path__ + "static/media/Item_Weapon_SmokeBomb_C.cf88d50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_SmokeBomb_C.png
// module id = ./src/assets/item/Weapon/Throwable/Item_Weapon_SmokeBomb_C.png
// module chunks = 0